import React from "react";
import { Button, Input, Space } from "antd";

const clock = { width: 130 };

export default function ShowBetweenField({ from, to, onChange }) {
  return (
    <>
      <label className="d-block mt-3 mb-1">Show between (optional)</label>
      <Space wrap>
        <Input type="time" aria-label="On at" value={from} onChange={(e) => onChange({ from: e.target.value, to })} style={clock} />
        <span className="text-muted">to</span>
        <Input type="time" aria-label="Off at" value={to} onChange={(e) => onChange({ from, to: e.target.value })} style={clock} />
        {(from || to) && <Button type="link" onClick={() => onChange({ from: "", to: "" })}>All day</Button>}
      </Space>
      <small className="d-block text-muted mt-1">
        India time. Leave both empty to show it all day. An off time before the on time runs past midnight, like 22:00 to 02:00.
      </small>
    </>
  );
}
